import { CloudPremisePluginMenu } from "@cloudpremise/portal_core";

const userMenus = (): CloudPremisePluginMenu[] => {
    return [
        // {
        //     name: "Edit Profile",
        //     key: "edit_profile",
        //     route: "/user/edit",
        //     privacy: "private",
        // },
    ];
};

export default userMenus;